/* eslint-disable @nx/enforce-module-boundaries */

import { Stack, HStack, Box, VStack } from '@mybridge/ui';
import { forwardRef } from 'react';
import { JobsListingLayout } from 'v4/snippets/jobs/layout';
import { JobsListingTabs } from 'v4/snippets/jobs/listing-tabs';
import { SuggestedJobsListing } from 'v4/snippets/jobs/suggested-listing';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { SiteShortcutLinks } from 'v4/snippets/dashboard/site-shortcut-links';
import { isMobile } from 'react-device-detect';
import { DashboardMyCircle } from 'v4/snippets/dashboard/circle';
// import styles from '../../../components/header/status-dropdown/statusProfile.module.scss';

export const JobsListingSuggestedPage = forwardRef(({ ...props }, ref) => {
  return (
    <AuthenticatedProviders>
      <JobsListingLayout>
      <HStack minH={!isMobile && "105vh"} spacing={2} alignItems="flex-start" flexGrow={1} maxW="1312px">{/* Use HStack for horizontal layout */}
          {!isMobile &&
          //  <HStack  pos={!isMobile && "sticky"} top={!isMobile && "64px"} h={!isMobile && "500px"}malignItems="stretch" spacing={0}>
           <Stack
             display={['none', 'none', 'flex']}
             pos="sticky"
             top="64px"
             spacing={2}
             //minH="100vh"
             borderBottom="1px solid #e0e0e094"
             height={'500px'}
             zIndex="999"
           >
             <VStack
               spacing={2}
               justifyContent="space-between"
               height="100%"
               align="stretch"
               h="calc(100vh - 0px)"
               backgroundColor="rgb(255, 255, 255)"
             >
               <VStack spacing={2} align="stretch" h="100%" flex="1" w="min-content">
                 <SiteShortcutLinks />
                 <Box
                  //  className={styles.hideTitle}
                 >
                   <DashboardMyCircle h="300px" flex="1" />
                 </Box>
               </VStack>
             </VStack>
           </Stack>
        //  </HStack>
          }
          <Stack spacing={4} flexGrow={1} > {/* Allow this stack to grow and fill the remaining space */}
            <JobsListingTabs active={0} />
            <SuggestedJobsListing />
          </Stack>
        </HStack>
      </JobsListingLayout>
    </AuthenticatedProviders>
  );
});

export default JobsListingSuggestedPage;